module.exports = __webpack_public_path__ + "img/docker-registry.7bcbbab5.png";